module.exports = __webpack_public_path__ + "static/media/leak-pod-action-alert.2abbc6d2.svg";